import React from 'react';
import ControlWidgetStyleSettings from './ControlWidgetStyleSettings';
import ImageButtonWidgetSettings from './ImageButtonWidgetSettings';
import LabelWidgetSettings from './LabelWidgetSettings';
import MenuOptionsSettings from './MenuOptionsSettings';
import SliderNumberSettings from './SliderNumberSettings';
import ValueColorSettings from './ValueColorSettings';
import WaterNetworkSettings from './WaterNetworkWidgetSettings';
import WidgetCommonToggleSettings from './WidgetCommonToggleSettings';
import {
	SHOW_UNIT_WIDGET_TYPES,
	VALUE_COLOR_WIDGET_TYPES,
} from '../layout/webDashboardConstants';
import { isWaterNetworkWidgetType } from '../../../utils/waterNetworkLayout';

const WidgetAdvancedSettings = ({
	edit,
	setEdit,
	t,
	selectedDatastream,
	directionLabels,
	getDsMinMax,
	themeColorKey,
	themeColorValue,
}) => (
	<>
		<ControlWidgetStyleSettings
			edit={edit}
			setEdit={setEdit}
			t={t}
			themeColorKey={themeColorKey}
			themeColorValue={themeColorValue}
		/>
		<ValueColorSettings
			edit={edit}
			setEdit={setEdit}
			t={t}
			selectedDatastream={selectedDatastream}
			getDsMinMax={getDsMinMax}
			themeColorKey={themeColorKey}
			themeColorValue={themeColorValue}
			valueColorWidgetTypes={VALUE_COLOR_WIDGET_TYPES}
		/>
		<WidgetCommonToggleSettings
			edit={edit}
			setEdit={setEdit}
			t={t}
			showUnitWidgetTypes={SHOW_UNIT_WIDGET_TYPES}
			isWaterNetworkWidgetType={isWaterNetworkWidgetType}
		/>
		<LabelWidgetSettings
			edit={edit}
			setEdit={setEdit}
			t={t}
			selectedDatastream={selectedDatastream}
			getDsMinMax={getDsMinMax}
			themeColorKey={themeColorKey}
			themeColorValue={themeColorValue}
		/>
		{(edit.type === 'menu' || edit.type === 'segment-switch') ? (
			<MenuOptionsSettings edit={edit} setEdit={setEdit} t={t} />
		) : ['pipe', 'elbow', 'water-pump'].includes(edit.type) ? (
			<WaterNetworkSettings
				edit={edit}
				setEdit={setEdit}
				t={t}
				directionLabels={directionLabels}
				themeColorKey={themeColorKey}
				themeColorValue={themeColorValue}
			/>
		) : edit.dataId > 0 && (edit.type === 'slider' || edit.type === 'number') ? (
			<SliderNumberSettings
				edit={edit}
				setEdit={setEdit}
				t={t}
				selectedDatastream={selectedDatastream}
				directionLabels={directionLabels}
				getDsMinMax={getDsMinMax}
				themeColorKey={themeColorKey}
				themeColorValue={themeColorValue}
			/>
		) : null}
		<ImageButtonWidgetSettings edit={edit} setEdit={setEdit} t={t} />
	</>
);

export default WidgetAdvancedSettings;
